import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-elements',
  imports: [CommonModule,FormsModule,ReactiveFormsModule],
  templateUrl: './form-elements.component.html',
  styleUrl: './form-elements.component.css'
})
export class FormElementsComponent {

  @Input() elements:any;
  @Input() parentForm:any;

}
